module.exports = __webpack_public_path__ + "img/gif_jije.dd073f3e.gif";